import {
  CapabilityPage,
  type CapabilitySection,
} from "@/components/marketing/CapabilityPage";

/**
 * ``/features/sklad-a-nakup`` — the first page of „Co umíme“.
 *
 * Eight screens, every one of them live today in the tenant
 * administration: storage locations, the hall map, the pick list, stock
 * movements, finished-goods intake, material batches, suppliers and
 * purchase orders.
 *
 * **Not one item carries an entitlement key, and that is the point.**
 * None of this is gated by a plan: the catalogue returned by
 * ``GET /public/plans`` has 25 keys and the warehouse is in none of
 * them, because it is on every tier. A page of a section whose other
 * pages wear plan badges, wearing none, says that better than a
 * sentence could — so the lead says it once in words and the page then
 * demonstrates it by being bare.
 */
const SECTIONS: readonly CapabilitySection[] = [
  // Where things are. The three screens a shop looks at before it
  // orders anything: places, the map over them, and what moved.
  {
    id: "stock",
    items: [{ id: "places" }, { id: "map" }, { id: "movements" }],
    shot: "warehouse-stock",
  },
  // Getting it out again — the half of a warehouse that people forget
  // when they think "stock levels".
  { id: "picking", items: [{ id: "pickList" }, { id: "finished" }], shot: "warehouse-picking" },
  { id: "buying", items: [{ id: "suppliers" }, { id: "orders" }], shot: "warehouse-buying" },
  // One card, so it spans the row (CapabilityPage) and the batch's
  // trace — part → material → supplier — stands under it (audit #60).
  { id: "traceability", items: [{ id: "batches" }], shot: "warehouse-traceability" },
];

const PAINS = ["lost", "ranOut", "whichHeat"] as const;

export default function FeaturesWarehouse(): JSX.Element {
  return (
    <CapabilityPage
      i18nKey="features.pages.warehouse"
      path="/features/sklad-a-nakup"
      pains={PAINS}
      sections={SECTIONS}
    />
  );
}
